import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import PersonalityQuizzesList from './components/PersonalityQuizzesList';
import PersonalityQuizCreate from './components/PersonalityQuizCreate';
import PersonalityQuizEdit from './components/PersonalityQuizEdit';
import { APP_TYPES, CAUCASUS_TYPES, roles } from '../../config/constants';

const ENV_APP_TYPE = process.env.REACT_APP_APP_TYPE;

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [APP_TYPES.HUNGARY, APP_TYPES.BELARUS, ...CAUCASUS_TYPES].includes(ENV_APP_TYPE)
    ? [roles.ADMIN]
    : [roles.ADMIN, roles.JTI_TEAM],
  label: 'Personality quizzes',
  subMenuName: 'content',
};

export default {
  list: PersonalityQuizzesList,
  create: PersonalityQuizCreate,
  edit: PersonalityQuizEdit,
  icon: AccessibilityNewIcon,
  name: 'admin/personality-quizzes',
  options,
};
